export { ThankYouWrapper } from './ThankYouWrapper';
